import { Box, Button, Stack, Text } from '@chakra-ui/react'
import { Link as ReactRouterLink } from 'react-router-dom'

import FirestoreUser from '../../../../types/FirestoreUser'
import {
  formatDateFull,
  formatDateMonth,
  formatDateString,
  formatDateMonthString,
} from '../../../../utils/formatDate'
import { formatPhoneDisplay } from '../../../../utils/formatPhone'
import { Email } from './Email'
import { Password } from './Password'

interface Props {
  user: FirestoreUser
  profile: FirestoreUser['profile'] | undefined
  uid: string
  isSuperAdmin: boolean
  isActingAsUser?: boolean
  onActAsUser: () => void
}

export function UserInfo({
  user,
  profile,
  uid,
  isSuperAdmin,
  isActingAsUser = false,
  onActAsUser,
}: Props) {
  return (
    <Stack spacing={0}>
      <Text>{user.email}</Text>
      <Text>
        {formatPhoneDisplay(profile?.phoneNumber, profile?.phoneCountryCode)}
      </Text>
      <Text>
        Joined Registry:{' '}
        {user.createdAt
          ? isSuperAdmin
            ? formatDateFull(user.createdAt)
            : formatDateMonth(user.createdAt)
          : 'N/A'}
      </Text>
      <Text>
        Diagnosis Date:{' '}
        {profile?.diagnosisDate
          ? isSuperAdmin
            ? formatDateString(profile.diagnosisDate)
            : formatDateMonthString(profile.diagnosisDate)
          : 'N/A'}
      </Text>
      <Box>
        <ReactRouterLink to={`/admin/users/${uid}/print`}>
          <Button variant='link'>Print Records</Button>
        </ReactRouterLink>
      </Box>
      <Box>
        <ReactRouterLink to={`/admin/users/${uid}/edit-profile`}>
          <Button variant='link'>Edit Profile / Upload Docs</Button>
        </ReactRouterLink>
      </Box>
      {isSuperAdmin && (
        <Box>
          <Button
            variant='link'
            onClick={onActAsUser}
            isLoading={isActingAsUser}
            loadingText='Starting...'
            title='Start a patient support session'
          >
            Act as User
          </Button>
        </Box>
      )}
      <Email uid={uid} />
      <Password uid={uid} />
    </Stack>
  )
}
